export const generateColor = (index) => {
  // Generate a color based on the index, ensuring it stays visible on a white background
  const hue = (index * 137) % 360; // Use a large prime number to distribute hues evenly
  const saturation = 80; // Keep saturation high for better visibility
  const lightness = 50; // Avoid light colors that blend into white

  // Convert HSL to CSS color format
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
